import React from 'react';
import { useMediaQuery } from '@mui/material';
import { Checkbox, IconButton, ResponsiveRow, Row, DatePicker } from 'library/ui';
import { addDays, addWeeks, startOfWeek, subDays, subWeeks } from 'date-fns';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import theme from 'theme';
import { formatDateFromDateObject } from 'shared/Dates';

export default function CalendarFilters({
    currentDay,
    setCurrentDay,
    showWeekend,
    setShowWeekend,
}: {
    currentDay: Date;
    setCurrentDay: (d: Date) => void;
    showWeekend: boolean;
    setShowWeekend: (show: boolean) => void;
}) {
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));

    function next() {
        const newDate = addWeeks(currentDay, 1);
        setCurrentDay(mdDown ? addDays(currentDay, 1) : startOfWeek(newDate));
    }

    function last() {
        const newDate = subWeeks(currentDay, 1);
        setCurrentDay(mdDown ? subDays(currentDay, 1) : startOfWeek(newDate));
    }

    return (
        <ResponsiveRow gap="md" collapseAt="lg" justify="end" align="center" alignWhenStacked="center">
            <Row gap="sm" justify={mdDown ? 'center' : 'end'}>
                {!mdDown && <Checkbox label="Show 7-day week" checked={showWeekend} onChange={setShowWeekend} />}
                <IconButton icon={ArrowBackIosIcon} onClick={last} />
                <DatePicker
                    value={currentDay ? formatDateFromDateObject(currentDay) : ''}
                    onChange={(value) => {
                        if (value) setCurrentDay(new Date(value));
                    }}
                />
                <IconButton icon={ArrowForwardIosIcon} onClick={next} />
            </Row>
        </ResponsiveRow>
    );
}
